/**
 * Created by fan on 3/2/17.
 */
angular.module('smartorg.r6.cmpts.stickybar').directive('stickyBar', ["$timeout", function ($timeout) {
        return {
            restrict: 'E',
            template: require('../../template/sticky-bar.html'),
            scope: {
                menuBox: '=?',
                title: '@?',
                position: '@?'
            },
            link: function (scope) {
                if (!scope.title) {
                    scope.title = "Workspace";
                }
                if (!scope.position) {
                    scope.position = "top";
                }
                scope.panelCollapsed = {
                    'left': false,
                    'right': false
                };
                scope.funcs = {
                    /**
                     * Handle share link function.
                     */
                    share: function () {
                        scope.$emit('workbench:share');
                    },
                    /**
                     * Shows Settings dialog.
                     */
                    config: function () {
                        scope.$emit('workbench:emit', {
                            command: 'PortfolioConfiguration',
                            saveGlobally: false,
                            showInputConfig: false
                        });
                    },
                    /**
                     * Show "Full screen";
                     */
                    expand: function () {
                        scope.$emit('workbench:toggle_panels', {
                            'show': true,
                            'panels': ['left', 'right', 'bottom']
                        });
                    },
                    /**
                     * Show left and right panel.
                     */
                    collapse: function () {
                        scope.$emit('workbench:toggle_panels', {
                            'show': false,
                            'panels': ['left', 'right']
                        });
                    },
                    /**
                     * Trigger display toggle. Item.toggle is dispay
                     * text of toggle.
                     *
                     * @param item {MenuListItem}
                     */
                    handleToggle: function (item) {
                        if (item.toggle) {
                            item.showToggle = !item.showToggle;
                        }
                    }
                };
                /**
                 * When a panel is opened or closed, update expand status.
                 */
                scope.$on('workbench:toggle_collapse', function (event, args) {
                    scope.panelCollapsed = args.status;
                    $timeout();
                });
            }
        };
    }]);
//# sourceMappingURL=sticky-bar-directive.js.map


// WEBPACK FOOTER //
// ./app/components/sticky-bar/app/js/plumbing/sticky-bar-directive.js